import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _237c6f1f = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "" */))
const _a59af55e = () => interopDefault(import('../modules/catalog/pages/AllAnalysesList.vue' /* webpackChunkName: "" */))
const _7e560a1c = () => interopDefault(import('../modules/catalog/pages/AnalysesList.vue' /* webpackChunkName: "" */))
const _1c7a55ba = () => interopDefault(import('../modules/catalog/pages/analysis.vue' /* webpackChunkName: "" */))
const _c0dd24b2 = () => interopDefault(import('../modules/checkout/pages/Cart.vue' /* webpackChunkName: "" */))
const _ccf5a566 = () => interopDefault(import('../modules/checkout/pages/Checkout.vue' /* webpackChunkName: "" */))
const _2ddc6ba4 = () => interopDefault(import('../modules/checkout/pages/Checkout/Payment.vue' /* webpackChunkName: "" */))
const _7fbe1ba7 = () => interopDefault(import('../modules/checkout/pages/Checkout/ThankYou.vue' /* webpackChunkName: "" */))
const _038f1c6a = () => interopDefault(import('../modules/checkout/pages/Checkout/PersonalInformation.vue' /* webpackChunkName: "" */))
const _58919339 = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _2cba9a18 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyAccount.vue' /* webpackChunkName: "" */))
const _ed65833c = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressesDetails.vue' /* webpackChunkName: "" */))
const _6e1c7e5e = () => interopDefault(import('../modules/customer/pages/MyAccount/MyProfile/MyProfile.vue' /* webpackChunkName: "" */))
const _0ab181e4 = () => interopDefault(import('../modules/customer/pages/MyAccount/MyWishlist.vue' /* webpackChunkName: "" */))
const _065592bc = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/OrderHistory.vue' /* webpackChunkName: "" */))
const _691474ae = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressNew.vue' /* webpackChunkName: "" */))
const _6d019c28 = () => interopDefault(import('../modules/customer/pages/MyAccount/AddressesDetails/AddressEdit.vue' /* webpackChunkName: "" */))
const _c425b9de = () => interopDefault(import('../modules/customer/pages/MyAccount/OrderHistory/SingleOrder/SingleOrder.vue' /* webpackChunkName: "" */))
const _0b006fe7 = () => interopDefault(import('../pages/CustomerService.vue' /* webpackChunkName: "pages/CustomerService" */))
const _136a095b = () => interopDefault(import('../modules/customer/pages/MyAccount/ForgotPassword.vue' /* webpackChunkName: "" */))
const _436c8e08 = () => interopDefault(import('../modules/customer/pages/MyAccount/Login.vue' /* webpackChunkName: "" */))
const _2b11090f = () => interopDefault(import('../modules/customer/pages/Reports/TestResultsHistory.vue' /* webpackChunkName: "" */))
const _73b184cf = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _1fa55b6b = () => interopDefault(import('../modules/catalog/pages/Packages.vue' /* webpackChunkName: "" */))
const _8d6eeb6e = () => interopDefault(import('../modules/clinics/pages/SamplingSites.vue' /* webpackChunkName: "" */))
const _6f42d4a0 = () => interopDefault(import('../modules/customer/pages/Reports/Reports.vue' /* webpackChunkName: "" */))
const _1d2cabf5 = () => interopDefault(import('../modules/customer/pages/Reports/TestResults.vue' /* webpackChunkName: "" */))
const _37475395 = () => interopDefault(import('../modules/customer/pages/MyAccount/Signup.vue' /* webpackChunkName: "" */))
const _063be31d = () => interopDefault(import('../modules/customer/pages/MyAccount/ResetPassword.vue' /* webpackChunkName: "" */))
const _3d89de4c = () => interopDefault(import('../modules/customer/pages/MyAccount/LoginAsCustomer.vue' /* webpackChunkName: "" */))
const _08d834d8 = () => interopDefault(import('../modules/catalog/pages/package.vue' /* webpackChunkName: "" */))
const _a9fed1c0 = () => interopDefault(import('../modules/clinics/pages/LabPage.vue' /* webpackChunkName: "" */))
const _702d743a = () => interopDefault(import('../modules/catalog/pages/Partner.vue' /* webpackChunkName: "" */))
const _0377f6eb = () => interopDefault(import('../modules/customer/pages/Reports/AnalysisResults.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/en",
    component: _237c6f1f,
    name: "home___en"
  }, {
    path: "/sv",
    component: _237c6f1f,
    name: "home___sv"
  }, {
    path: "/en/alla-analyser",
    component: _a59af55e,
    meta: {"titleLabel":"Analyses List"},
    name: "analysis list___en"
  }, {
    path: "/en/analys",
    component: _7e560a1c,
    meta: {"titleLabel":"Analyses List"},
    name: "analyses___en",
    children: [{
      path: ":slug",
      component: _1c7a55ba,
      meta: {"titleLabel":"Analysis"},
      name: "simple analysis___en"
    }]
  }, {
    path: "/en/cart",
    component: _c0dd24b2,
    name: "cart___en"
  }, {
    path: "/en/checkout",
    component: _ccf5a566,
    name: "checkout___en",
    children: [{
      path: "payment",
      component: _2ddc6ba4,
      name: "payment___en"
    }, {
      path: "thank-you",
      component: _7fbe1ba7,
      name: "thank-you___en"
    }, {
      path: "your-info",
      component: _038f1c6a,
      name: "your-info___en"
    }]
  }, {
    path: "/en/Cms",
    component: _58919339,
    name: "Cms___en"
  }, {
    path: "/en/customer",
    component: _2cba9a18,
    meta: {"titleLabel":"My Account"},
    name: "customer___en",
    children: [{
      path: "addresses-details",
      component: _ed65833c,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___en"
    }, {
      path: "my-profile",
      component: _6e1c7e5e,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___en"
    }, {
      path: "my-wishlist",
      component: _0ab181e4,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___en"
    }, {
      path: "order-history",
      component: _065592bc,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___en"
    }, {
      path: "addresses-details/create",
      component: _691474ae,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___en"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _6d019c28,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___en"
    }, {
      path: "order-history/:orderId",
      component: _c425b9de,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___en"
    }]
  }, {
    path: "/en/CustomerService",
    component: _0b006fe7,
    name: "CustomerService___en"
  }, {
    path: "/en/forgot-password",
    component: _136a095b,
    meta: {"titleLabel":"Forgot Password"},
    name: "forgot password___en"
  }, {
    path: "/en/Home",
    component: _237c6f1f,
    name: "Home___en"
  }, {
    path: "/en/kundtjanst",
    component: _0b006fe7,
    name: "customer service___en"
  }, {
    path: "/en/login",
    component: _436c8e08,
    meta: {"titleLabel":"Log In"},
    name: "login___en"
  }, {
    path: "/en/mina-testresultat",
    component: _2b11090f,
    meta: {"titleLabel":"Test Results History"},
    name: "test results history___en"
  }, {
    path: "/en/Page",
    component: _73b184cf,
    name: "Page___en"
  }, {
    path: "/en/provanalyser",
    component: _1fa55b6b,
    meta: {"titleLabel":"Packages List"},
    name: "package list___en"
  }, {
    path: "/en/provtagningsstallen",
    component: _8d6eeb6e,
    name: "sampling-sites___en"
  }, {
    path: "/en/reports",
    component: _6f42d4a0,
    meta: {"titleLabel":"Reports"},
    name: "reports___en",
    children: [{
      path: "/en/reports/:reportOrderId",
      component: _1d2cabf5,
      meta: {"titleLabel":"Test Results"},
      name: "test results___en"
    }]
  }, {
    path: "/en/signup",
    component: _37475395,
    meta: {"titleLabel":"Sign Up"},
    name: "signup___en"
  }, {
    path: "/sv/alla-analyser",
    component: _a59af55e,
    meta: {"titleLabel":"Analyses List"},
    name: "analysis list___sv"
  }, {
    path: "/sv/analys",
    component: _7e560a1c,
    meta: {"titleLabel":"Analyses List"},
    name: "analyses___sv",
    children: [{
      path: ":slug",
      component: _1c7a55ba,
      meta: {"titleLabel":"Analysis"},
      name: "simple analysis___sv"
    }]
  }, {
    path: "/sv/cart",
    component: _c0dd24b2,
    name: "cart___sv"
  }, {
    path: "/sv/checkout",
    component: _ccf5a566,
    name: "checkout___sv",
    children: [{
      path: "payment",
      component: _2ddc6ba4,
      name: "payment___sv"
    }, {
      path: "thank-you",
      component: _7fbe1ba7,
      name: "thank-you___sv"
    }, {
      path: "your-info",
      component: _038f1c6a,
      name: "your-info___sv"
    }]
  }, {
    path: "/sv/Cms",
    component: _58919339,
    name: "Cms___sv"
  }, {
    path: "/sv/customer",
    component: _2cba9a18,
    meta: {"titleLabel":"My Account"},
    name: "customer___sv",
    children: [{
      path: "addresses-details",
      component: _ed65833c,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details___sv"
    }, {
      path: "my-profile",
      component: _6e1c7e5e,
      meta: {"titleLabel":"My profile"},
      name: "customer-my-profile___sv"
    }, {
      path: "my-wishlist",
      component: _0ab181e4,
      meta: {"titleLabel":"My wishlist"},
      name: "customer-my-wishlist___sv"
    }, {
      path: "order-history",
      component: _065592bc,
      meta: {"titleLabel":"Order history"},
      name: "customer-order-history___sv"
    }, {
      path: "addresses-details/create",
      component: _691474ae,
      meta: {"titleLabel":"Addresses details"},
      name: "customer-addresses-details-new___sv"
    }, {
      path: "addresses-details/edit/:addressId",
      component: _6d019c28,
      meta: {"titleLabel":"Addresses details"},
      props: true,
      name: "customer-addresses-details-edit___sv"
    }, {
      path: "order-history/:orderId",
      component: _c425b9de,
      meta: {"titleLabel":"Order history"},
      props: true,
      name: "customer-single-order___sv"
    }]
  }, {
    path: "/sv/CustomerService",
    component: _0b006fe7,
    name: "CustomerService___sv"
  }, {
    path: "/sv/forgot-password",
    component: _136a095b,
    meta: {"titleLabel":"Forgot Password"},
    name: "forgot password___sv"
  }, {
    path: "/sv/Home",
    component: _237c6f1f,
    name: "Home___sv"
  }, {
    path: "/sv/kundtjanst",
    component: _0b006fe7,
    name: "customer service___sv"
  }, {
    path: "/sv/login",
    component: _436c8e08,
    meta: {"titleLabel":"Log In"},
    name: "login___sv"
  }, {
    path: "/sv/mina-testresultat",
    component: _2b11090f,
    meta: {"titleLabel":"Test Results History"},
    name: "test results history___sv"
  }, {
    path: "/sv/Page",
    component: _73b184cf,
    name: "Page___sv"
  }, {
    path: "/sv/provanalyser",
    component: _1fa55b6b,
    meta: {"titleLabel":"Packages List"},
    name: "package list___sv"
  }, {
    path: "/sv/provtagningsstallen",
    component: _8d6eeb6e,
    name: "sampling-sites___sv"
  }, {
    path: "/sv/reports",
    component: _6f42d4a0,
    meta: {"titleLabel":"Reports"},
    name: "reports___sv",
    children: [{
      path: "/sv/reports/:reportOrderId",
      component: _1d2cabf5,
      meta: {"titleLabel":"Test Results"},
      name: "test results___sv"
    }]
  }, {
    path: "/sv/signup",
    component: _37475395,
    meta: {"titleLabel":"Sign Up"},
    name: "signup___sv"
  }, {
    path: "/en/customer/account/createPassword",
    component: _063be31d,
    name: "reset-password___en"
  }, {
    path: "/en/loginascustomer/login/index",
    component: _3d89de4c,
    name: "login-as-customer___en"
  }, {
    path: "/sv/customer/account/createPassword",
    component: _063be31d,
    name: "reset-password___sv"
  }, {
    path: "/sv/loginascustomer/login/index",
    component: _3d89de4c,
    name: "login-as-customer___sv"
  }, {
    path: "/en/analyspaket/:slug",
    component: _08d834d8,
    meta: {"titleLabel":"Package"},
    name: "package___en"
  }, {
    path: "/en/mottagning/:slug",
    component: _a9fed1c0,
    name: "laboratory___en"
  }, {
    path: "/en/partner/:slug",
    component: _702d743a,
    meta: {"titleLabel":"Partner"},
    name: "partner___en"
  }, {
    path: "/sv/analyspaket/:slug",
    component: _08d834d8,
    meta: {"titleLabel":"Package"},
    name: "package___sv"
  }, {
    path: "/sv/mottagning/:slug",
    component: _a9fed1c0,
    name: "laboratory___sv"
  }, {
    path: "/sv/partner/:slug",
    component: _702d743a,
    meta: {"titleLabel":"Partner"},
    name: "partner___sv"
  }, {
    path: "/en/reports/:reportOrderId/:analysisResultId",
    component: _0377f6eb,
    meta: {"titleLabel":"Analysis Results"},
    name: "analysis results___en"
  }, {
    path: "/sv/reports/:reportOrderId/:analysisResultId",
    component: _0377f6eb,
    meta: {"titleLabel":"Analysis Results"},
    name: "analysis results___sv"
  }, {
    path: "/en/:slug",
    component: _73b184cf,
    name: "page___en"
  }, {
    path: "/sv/:slug",
    component: _73b184cf,
    name: "page___sv"
  }, {
    path: "/en/:parentSlug/analys",
    component: _7e560a1c,
    meta: {"titleLabel":"Package Analyses List"},
    name: "package analyses___en",
    children: [{
      path: ":slug",
      component: _1c7a55ba,
      meta: {"titleLabel":"Package Analysis"},
      name: "simple package analysis___en"
    }]
  }, {
    path: "/sv/:parentSlug/analys",
    component: _7e560a1c,
    meta: {"titleLabel":"Package Analyses List"},
    name: "package analyses___sv",
    children: [{
      path: ":slug",
      component: _1c7a55ba,
      meta: {"titleLabel":"Package Analysis"},
      name: "simple package analysis___sv"
    }]
  }, {
    path: "/en/:parentSlug/:slug",
    component: _73b184cf,
    name: "subpage___en"
  }, {
    path: "/sv/:parentSlug/:slug",
    component: _73b184cf,
    name: "subpage___sv"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
